import { defineComponent as _defineComponent } from 'vue'
import { nextTick } from '../../../adapter-vue';
import {
  TUITranslateService,
  IGroupModel,
} from '@tencentcloud/chat-uikit-engine';
import { watchEffect, ref } from '../../../adapter-vue';
import { Toast, TOAST_TYPE } from '../../common/Toast/index';
import { isUniFrameWork } from '../../../utils/env';


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-notification',
  props: {
  data: {
    type: Object,
    default: () => ({}),
  },
  isAuthor: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update', 'close'],
  setup(__props, { emit: emits }) {

const props = __props



const groupProfile = ref<IGroupModel>({});
const input = ref('');
const isAuthorNotification = ref(false);
const isEdit = ref(false);

watchEffect(() => {
  groupProfile.value = props.data;
  input.value = groupProfile.value.notification;
  isAuthorNotification.value = props.isAuthor;
});



const updateProfile = () => {
  if (input.value.length > 150) {
    Toast({
      message: TUITranslateService.t('TUIGroup.群公告字数超出限制，最大长度为150'),
      type: TOAST_TYPE.ERROR,
    });
    return;
  }
  if (input.value && input.value !== groupProfile.value.notification) {
    emits('update', { key: 'notification', value: input.value });
    nextTick(() => {
      input.value = '';
    });
  }
  isEdit.value = !isEdit.value;
};

const close = (tabName: string) => {
  emits('close', tabName);
};

return { __sfc: true,props, groupProfile, input, isAuthorNotification, isEdit, emits, updateProfile, close, TUITranslateService, isUniFrameWork }
}

})